export default __webpack_public_path__ + "static/media/stokerverse-rpg-authors-pack.3d433052.png";